export const feedback = [
    {
        text: "Before Tixu, I wasted hours on manual work. Now, AI does it in minutes, and I can focus on bigger projects that actually grow my income.",
        name: "Elena M.",
        profession: "Marketing Strategist",
        imageUrl: "/images/feedback/1.png"
    },
    {
        text: "I kept hearing about AI, but I had no idea how to use it. Tixu broke it down step by step. Now I’m automating my tasks and getting more done with less effort.",
        name: "Daniel P.",
        profession: "Small Business Owner",
        imageUrl: "/images/feedback/2.png"
    },
    {
        text: "My colleagues were using AI, and I felt like I was falling behind. Tixu helped me catch up fast. Now, I’m the one sharing AI tips at work.",
        name: "Marcus L.",
        profession: "Project Manager",
        imageUrl: "/images/feedback/3.png"
    },
    {
        text: "Tixu didn’t just teach me AI. It showed me how to use it to land higher-paying clients. My work is now twice as fast, and I charge more for it.",
        name: "Jordan K.",
        profession: "Freelancer",
        imageUrl: "/images/feedback/4.png"
    }
];

export const screenShotes = [
    "/images/onboarding/png/paywall/app-screen-1.png",
    "/images/onboarding/png/paywall/app-screen-2.png",
    "/images/onboarding/png/paywall/app-screen-3.png"
];

export const loaderScreenFeedbacks = [
    {
        author: "Emily Davis",
        title: "Extensive knowledge",
        comment:
            "In addition to Al insights, Tixu.ai offered me extensive marketing knowledge. It’s less about the cost and more about the value."
    },
    {
        author: "Alex Johnson",
        title: "The experience is topnotch",
        comment:
            "The Al knowledge l've gained from the program can be immediately applied in my job. I've acquired skills that enhance my efficiency and effectiveness at work."
    },
    {
        author: "Sarah Mitchell",
        title: "Outstanding platform",
        comment: "Tixu.ai enables individuals at all levels of expertise to easily understand complicated Al topics."
    }
];

export const daysChallange = [
    { title: "DeepSeek", icon: "/images/onboarding/emojies/deep-seek.svg" },
    { title: "ChatGPT", icon: "/images/onboarding/emojies/chat-gpt.svg" },
    { title: "HubSpot", icon: "/images/onboarding/emojies/hub-spot.svg" },
    { title: "Canva", icon: "/images/onboarding/emojies/canva.svg" },
    { title: "Jasper AI", icon: "/images/onboarding/emojies/jasper.svg" },
    { title: "Gemini", icon: "/images/onboarding/emojies/google-gimini.svg" },
    { title: "Crystal", icon: "/images/onboarding/emojies/crystal.svg" }
];

export const landingFeedbacks = [
    {
        image: "/images/landing/png/user-section-8-1.png",
        comment:
            "I had zero experience with AI. Tixu helped me launch a booking chatbot for my salon, and it runs every day without me. I finally have time to grow the business instead of answering messages.",
        author: "Carlos",
        profit: "+$1200 first month"
    },
    {
        image: "/images/landing/png/user-section-8-2.png",
        comment:
            "I thought AI was only for tech people. After a week on Tixu, I started using it in client work and doubled my output. Now I finish projects faster and actually enjoy the process.",
        author: "Emily",
        profit: "Saves 7 hours a week"
    },
    {
        image: "/images/landing/png/user-section-8-3.png",
        comment:
            "As a freelancer, I was constantly buried in repetitive work. Tixu showed me how to use AI to speed up content creation and free up time for better-paying clients.",
        author: "Noah",
        profit: "+$1300 in 30 days"
    }
];

export const landingFaq = [
    {
        id: "landing-faq-1",
        shortText: "1. What if I don’t like it?",
        fullText:
            "If you feel that our content doesn’t bring you value, you may be eligible for a full refund — we’re open to it. Certain conditions apply, and you can find the full details in our ",
        link: {
            href: "/subscription-terms",
            text: "Subscription Terms."
        }
    },
    {
        id: "landing-faq-2",
        shortText: "2. Do I need any experience to start?",
        fullText:
            "Not at all. Most of our users start with zero background in AI. The lessons are designed for real beginners — no tech talk, just clear, useful actions you can take immediately."
    },
    {
        id: "landing-faq-3",
        shortText: "3. Can I cancel anytime?",
        fullText:
            "Yes. You can manage your subscription from your profile on the website or in the app. Cancel, pause, or switch plans whenever you want. No hidden fees, no complications."
    },
    {
        id: "landing-faq-4",
        shortText: "4. How much time does it take per day?",
        fullText:
            "On average, 15 to 20 minutes is enough to complete a lesson or a challenge task. You can go faster if you want. Tixu is built to fit into your daily schedule, not take it over."
    },
    {
        id: "landing-faq-5",
        shortText: "5. Will I actually learn useful skills?",
        fullText:
            "Yes. We’re not here to “wow” you with theory. Each lesson is built to help you create something — a chatbot, a landing page, an illustration, a sales deck. This isn’t just learning. It’s hands-on and results-driven."
    }
];

export const landingCourses = [
    {
        title: "ChatGPT",
        description: "3 topics",
        image: "/images/landing/png/human-section-8-1.png",
        color: "#A1F7CF"
    },
    {
        title: "Midjourney",
        description: "3 topics",
        image: "/images/landing/png/human-section-8-2.png",
        color: "#DCECFC"
    },
    {
        title: "Jasper AI",
        description: "3 topics",
        image: "/images/landing/png/human-section-8-3.png",
        color: "#FFECB2"
    },
    {
        title: "DALL-E",
        description: "3 topics",
        image: "/images/landing/png/human-section-8-4.png",
        color: "#FFAFCA"
    },
    {
        title: "Create Websites Without Coding in 5 Minutes",
        description: "1 topic",
        image: "/images/landing/png/human-section-8-5.png",
        color: "#DCECFC"
    },
    {
        title: "Opportunities with AI",
        description: "5 topics",
        image: "/images/landing/png/human-section-8-6.png",
        color: "#CDB4DB"
    },
    {
        title: "AI Image Income",
        description: "3 topics",
        image: "/images/landing/png/human-section-8-7.png",
        color: "#FFECB2"
    },
    {
        title: "Make money on AI logo design",
        description: "1 topic",
        image: "/images/landing/png/human-section-8-8.png",
        color: "#FFAFCA"
    },
    {
        title: "Make Money Creating Presentations",
        description: "1 topic",
        image: "/images/landing/png/human-section-8-9.png",
        color: "#A1F7CF"
    },
    {
        title: "Make money on AI CV",
        description: "1 topic",
        image: "/images/landing/png/human-section-8-10.png",
        color: "#DCECFC"
    }
];

export const loaderScreenIndianFeedbacks = [
    {
        author: "Priya Sharma",
        title: "Truly a wonderful platform",
        comment:
            "Tixu.ai empowers individuals at every skill level to easily grasp complex AI topics. It has truly been a valuable addition to my learning journey."
    },
    {
        author: "Rahul Verma",
        title: "A rewarding experience",
        comment:
            "The AI skills I have gained through this program are immediately useful in my professional life. I am able to upskill myself and enhance my efficiency at work."
    },
    {
        author: "Anjali Patel",
        title: "Valuable knowledge beyond expectations",
        comment:
            "Apart from deep AI insights, Tixu.ai provided extensive marketing knowledge as well. It’s not just about the fees; the real value I received is far greater."
    }
];

export const bloggerLandingFaq = [
    {
        id: "landing-faq-1",
        shortText: "Do I need experience working with AI to participate?",
        fullText:
            "No, the challenge is suitable for beginners. We will start with the basics and gradually delve into more advanced techniques."
    },
    {
        id: "landing-faq-2",
        shortText: "How much time do I need to dedicate to the challenge daily?",
        fullText:
            "It is recommended to allocate 1-2 hours a day for completing tasks and studying materials. Some tasks may take longer."
    },
    {
        id: "landing-faq-3",
        shortText: "How are the winners of the contest determined?",
        fullText:
            "Winners are determined by a combination of factors: audience growth, quality of created content, community engagement, and adherence to the challenge instructions."
    },
    {
        id: "landing-faq-4",
        shortText: "Do I need to appear on camera?",
        fullText: "No, everything can be done using AI avatars."
    },
    {
        id: "landing-faq-5",
        shortText: "Are tools included in the challenge?",
        fullText: "There is an AI chat in Tixu, but everything else is not included."
    }
];

export const bloggerLandingScreenshotes = [
    {
        id: "screenshot-1",
        text: "Tixu teaches you how to use AI with fast, hands-on lessons",
        image: "/images/bloggers-landing/png/section-10-1.png"
    },
    {
        id: "screenshot-2",
        text: "Learn by doing — practice right inside the platform",
        image: "/images/bloggers-landing/png/section-10-2.png"
    },
    {
        id: "screenshot-3",
        text: "Your AI chat is always there to help, with no extra cost",
        image: "/images/bloggers-landing/png/section-10-3.png"
    }
];

export const bloggerLandingWeeks = [
    {
        title: "AI for growth and engagement",
        content: [
            "Understand how AI can help bloggers grow their audience",
            "Automated video content creation",
            "Analysis of competitors' content"
        ]
    },
    {
        title: "AI avatar & video generation",
        content: [
            "Learn what an AI avatar is and how to create one",
            "Master the art of creating videos with AI",
            "Create content fillers for your blog"
        ]
    },
    {
        title: "End-to-end production",
        content: [
            "Create content with AI — from script to finished video",
            "Learn how to automatically publish content across various social media",
            "Discover how to edit a video using AI"
        ]
    },
    {
        title: "Strategy & scaling",
        content: [
            "Explore your target audience with AI",
            "Learn to develop a content strategy",
            "Create a long-term content strategy"
        ]
    }
];

export const bloggersLandingSkills = [
    {
        id: "id-skills-1",
        image: "/images/onboarding/emojies/clock.svg",
        text: "Generate ideas, scripts, and videos with AI in just minutes."
    },
    {
        id: "id-skills-2",
        image: "/images/onboarding/emojies/boy.svg",
        text: "Create an AI avatar with HeyGen that looks like you."
    },
    {
        id: "id-skills-3",
        image: "/images/onboarding/emojies/selfie.svg",
        text: "Shoot and edit videos from start to finish without manual cuts."
    },
    {
        id: "id-skills-4",
        image: "/images/onboarding/emojies/bar-chart.svg",
        text: "Plan a content strategy that speaks to your audience"
    },
    {
        id: "id-skills-5",
        image: "/images/onboarding/emojies/planet-earth.svg",
        text: "Automatically publish videos across all platforms at once"
    },
    {
        id: "id-skills-6",
        image: "/images/onboarding/emojies/chart-increasing.svg",
        text: "Track metrics and quickly adjust your posts"
    },
    {
        id: "id-skills-7",
        image: "/images/onboarding/emojies/magnifying-glass.svg",
        text: "Analyze competitors and adapt best practices"
    },
    { id: "id-skills-8", image: "/images/onboarding/emojies/bullseye.svg", text: "And much more" }
];

export const landingProfessions = ["Freelance", "Design", "Code", "Content", "Marketing", "Business"];

// Natural-key templates; {{days}} is interpolated at the render site.
export const STREAK_MODAL_HEADERS = [
    "{{days}}-day streak — keep it rolling!",
    "Keep rolling — {{days}}-day streak strong!",
    "On a {{days}}-day streak — you’ve got this!",
    "Streak of {{days}} days — keep it up!",
    "You’re {{days}} days in a row — awesome work!",
    "Stay on track with your {{days}}-day streak!",
    "{{days}}-day streak in progress — let’s go!",
    "Own it — {{days}} days and counting!"
];

export const STREAK_MODAL_SUBHEADERS = [
    "Practice daily to keep your streak alive.",
    "Keep the chain unbroken — {{days}} days running.",
    "One session at a time, you’re {{days}} days strong.",
    "Stay consistent, day by day, for {{days}} days.",
    "Don’t break the chain — you’ve hit {{days}} days.",
    "Every day counts, and you’re at {{days}} days!",
    "Keep showing up — {{days}} days and counting.",
    "A day at a time leads to {{days}} days of growth."
];
